import { toast } from 'react-toastify';

export const showToastForErrors = (error: any, knownErrors: string | string[], fallbackMessage?: string) => {
  const messages = Array.isArray(knownErrors) ? knownErrors : [knownErrors];

  if (
    !!error &&
    typeof error === 'object' &&
    'message' in error &&
    !!error.message &&
    typeof error.message === 'string'
  ) {
    for (const message of messages) {
      if (error.message.includes(message)) {
        toast.error(error.message.substring(error.message.indexOf(message)));
        return;
      }
    }
  }

  if (fallbackMessage) {
    toast.error(fallbackMessage);
  }
};
